import keyMirror from "keymirror";

export default keyMirror({
    POSTER: null,
    EXPERT: null,
    SYSTEM: null,
    BOT: null,
});
